import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <img style={{ height: "600px", objectFit: "cover", }} className="  img-fluid " src={"https://static.vecteezy.com/system/resources/previews/001/384/282/non_2x/404-error-concept-for-landing-page-design-free-vector.jpg"} alt="" />
        </div>
    );
};

export default NotFound;